"use client";
import React, { useEffect, useState } from "react";
import "@/src/components/Home/LandingV6/landing-v6.css";
import { Nav } from "@/src/components/Home/LandingV6/ui";
import { Footer } from "@/src/components/Home/LandingV6/blocks";
import { CornerPin, Squiggle } from "@/src/components/Home/LandingV6/ornaments";
import { COMPARISONS } from "./data";

export default function VsIndexPage() {
  const [theme, setTheme] = useState("paper");
  useEffect(() => {
    try {
      const s = window.localStorage.getItem("qv6-theme");
      if (s === "paper" || s === "midnight") setTheme(s);
    } catch (_) {}
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Quarkle AI writing tool comparisons",
    url: "https://quarkle.ai/vs",
    description: "First-party-sourced comparisons of Quarkle and other fiction writing tools.",
    mainEntity: {
      "@type": "ItemList",
      itemListElement: COMPARISONS.map((comparison, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: `Quarkle vs. ${comparison.name}`,
        url: `https://quarkle.ai/vs/${comparison.slug}`,
      })),
    },
  };

  return (
    <div className={`qv6 ${theme === "midnight" ? "theme-midnight" : ""}`}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Nav />

      <section style={{ padding: "80px 40px 50px", textAlign: "center" }}>
        <div style={{ maxWidth: 780, margin: "0 auto" }}>
          <CornerPin color="var(--pink)">honest comparisons</CornerPin>
          <h1 className="tanker" style={{ fontSize: "clamp(48px, 7vw, 108px)", lineHeight: 0.94, letterSpacing: "-0.035em", margin: "16px 0 18px" }}>
            how quarkle <span className="display" style={{ fontStyle: "italic", color: "var(--pink)" }}>compares</span>.
          </h1>
          <p className="display" style={{ fontSize: 19, fontStyle: "italic", opacity: 0.82, lineHeight: 1.55 }}>
            a short, factual read on each tool: what it's for, the trade-offs, and where quarkle's control, memory, and editing room differ.
          </p>
        </div>
      </section>

      <section style={{ padding: "20px 40px 100px" }}>
        <div className="qv6-vs-index-grid" style={{ maxWidth: 1000, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 22 }}>
          {COMPARISONS.map((c) => (
            <a
              key={c.slug}
              href={`/vs/${c.slug}`}
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "flex",
                flexDirection: "column",
                background: "var(--paper-3)",
                border: "1.5px solid var(--ink)",
                borderRadius: 12,
                padding: "26px 24px",
                boxShadow: "6px 6px 0 var(--ink)",
                transition: "transform 0.15s ease",
              }}
            >
              <span className="caps" style={{ color: c.accent }}>vs. {c.name.toLowerCase()}</span>
              <h2 className="tanker" style={{ fontSize: 32, margin: "8px 0 0", lineHeight: 1 }}>{c.name}</h2>
              <Squiggle w={90} h={8} color={c.accent} />
              <p className="mono" style={{ fontSize: 11, opacity: 0.55, marginTop: 10, textTransform: "uppercase", letterSpacing: "0.08em" }}>
                {c.dek}
              </p>
              <p className="display" style={{ fontSize: 15, fontStyle: "italic", lineHeight: 1.5, opacity: 0.85, marginTop: 10 }}>
                {c.summary}
              </p>
              <span className="mono" style={{ fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", color: c.accent, display: "inline-block", marginTop: "auto", paddingTop: 14 }}>
                read the comparison →
              </span>
            </a>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
